<app-modal
  [modalId]="modalId"
  [title]="title"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [showButtons]="true"
  (save)="submit()"
  [showClose]="true"
  [disabled]="draftInvalid"
  [contentTemplate]="requestTemplate"
  [saveText]="saveText"
></app-modal>

<ng-template #requestTemplate>
  @if (showInfo) {
    <div class="request-dialog__sub-header">
      <mat-icon class="request-dialog__modal-icon">warning</mat-icon>
      {{ 'request.modals.requestInfo' | translate }}
    </div>
  }
  <form>
    @if (type === RequestType.SKILL) {
      <app-ci-select
        class="request-dialog__category"
        name="category"
        [(ngModel)]="draft.kategorie"
        #categoryField="ngModel"
        [required]="true"
        [items]="categoryOptions"
        [label]="'request.modals.fieldIn.category' | translate: {language: ('languages.' + language | translate)}"
        [ariaLabel]="'request.modals.fieldIn.category' | translate: {language: ('languages.' + language | translate)}"
        [placeholder]="'skillCategorySelect.placeholder' | translate"
        [searchPlaceholder]="'skillCategorySelect.search' | translate"
        [searchClearLabel]="'ciSelect.clearSearch' | translate"
        [emptyLabel]="'skillCategorySelect.empty' | translate"
        [hitTemplate]="'ciSelect.hits' | translate"
        [invalid]="!!(categoryField.invalid && categoryField.touched)"
        [errorText]="'request.modals.categoryRequired' | translate"
      ></app-ci-select>
      <mat-form-field class="request-dialog__form-field">
        <mat-label>{{ 'request.modals.fieldIn.skill' | translate: {language: ('languages.' + language | translate)} }}</mat-label>
        <input
          matInput
          name="requests"
          [(ngModel)]="draft.faehigkeit"
          [maxlength]="LIMITS.SHORT_LABEL"
          #skillField="ngModel"
          required
        />
        <mat-hint align="end">{{ (draft.faehigkeit?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
        @if (skillField.hasError('required') && skillField.touched) {
          <mat-error>{{ 'request.modals.nameRequired' | translate }}</mat-error>
        }
      </mat-form-field>
    } @else {
      <mat-form-field class="request-dialog__form-field">
        <mat-label>
          {{ (type === RequestType.INDUSTRY ? 'request.modals.fieldIn.industry' : 'request.modals.fieldIn.mainFocus')
            | translate: {language: ('languages.' + language | translate)} }}
        </mat-label>
        <input
          matInput
          name="requests"
          [(ngModel)]="draft.name"
          [maxlength]="LIMITS.SHORT_LABEL"
          #nameField="ngModel"
          required
        />
        <mat-hint align="end">{{ (draft.name?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
        @if (nameField.hasError('required') && nameField.touched) {
          <mat-error>{{ 'request.modals.nameRequired' | translate }}</mat-error>
        }
      </mat-form-field>
    }
    @if (hasControlCharacters) {
      <p class="request-dialog__error" role="alert">{{ 'request.modals.controlCharacters' | translate }}</p>
    }
  </form>
</ng-template>

<app-modal
  [modalId]="modalId + 'Duplicate'"
  [title]="'request.duplicate.header'"
  [(visible)]="showDuplicateModal"
  [showButtons]="false"
  [showClose]="true"
  (cancel)="closeDuplicate()"
  [contentTemplate]="duplicateTemplate"
></app-modal>

<ng-template #duplicateTemplate>
  <p>
    {{ (canUseDuplicate ? 'request.duplicate.question'
      : duplicate?.approved ? 'request.duplicate.exists' : 'request.duplicate.pending') | translate }}
  </p>
  <dl class="request-dialog__duplicate">
    @for (option of languages; track option) {
      <dt>{{ 'languages.' + option | translate }}</dt>
      <dd>
        @if (duplicateNames(option); as names) {
          {{ names }}
        } @else {
          <span class="request-dialog__missing">{{ 'request.table.missing' | translate }}</span>
        }
      </dd>
    }
  </dl>
  <div class="request-dialog__actions">
    <button mat-raised-button type="button" (click)="changeInput()">
      {{ 'request.duplicate.changeText' | translate }}
    </button>
    <button mat-flat-button color="primary" type="button" (click)="useDuplicate()">
      {{ (canUseDuplicate ? 'request.duplicate.useExisting' : 'general.close') | translate }}
    </button>
  </div>
</ng-template>
